<div class="flex flex-col justify-between">
  <h3>Unmatched locks from a property</h3>
  <p>By saving these changes, some locks will be unlinked from the current property. As a result:</p>
  <ul class="list list__looser">
    <li>All access codes associated with active reservations at this property will be permanently deleted.</li>
    <li>If you re-link the lock to this property later, new access codes will be automatically generated.</li>
  </ul>

  <div class="flex justify-end items-center gap-4 mt-10">
    <sbnb-button type="secondary" (clicked)="cancelClicked()">Back</sbnb-button>
    <sbnb-button (clicked)="okClicked()">Confirm</sbnb-button>
  </div>
</div>
